// extracted by mini-css-extract-plugin
export var block = "List-module--block--b69f8";
export var content = "List-module--content--39880";
export var link = "List-module--link--191ee";
export var tagPill = "List-module--tagPill--3eda7";